import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'default-input',
  props: ["mode"],
  setup(__props) {

const props = __props;
const mode = computed(() => {
  return props.mode || "normal";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps(_ctx.$attrs, {
    class: ["border border-solid border-[#5e9822] py-3 px-5 text-sm bg-transparent outline-none", {
      'text-white': mode.value === 'dark',
      'text-[#333333]': mode.value === 'normal',
    }]
  }), null, 16))
}
}

})